/**
 * Utility functions for iframe communication
 */

export interface IframeMessage {
  type: string;
  jobId?: string;
}

/**
 * Send a message to the parent window if this app is embedded in an iframe
 * @param message - The message to send
 */
export const sendMessageToParent = (message: IframeMessage): void => {
  if (window.parent && window.parent !== window) {
    try {
      window.parent.postMessage(message, '*');
    } catch (error) {
      console.warn('Failed to send message to parent window:', error);
    }
  }
};

/**
 * Send a job stats refresh notification to the parent window
 * @param jobId - The job ID
 */
export const notifyJobStatsRefresh = (jobId: string): void => {
  sendMessageToParent({
    type: 'JOB_STATS_REFRESH',
    jobId,
  });
};

export const notifyExpenseCreate = (jobId: string): void => {
  sendMessageToParent({
    type: 'EXPENSE_CREATE',
    jobId,
  });
};
